import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IModalSlice {
  showPrimaryModal: boolean;
  showSecondaryModal: boolean;
  primaryModalContentOf: string;
  secondaryModalContentOf: string;
  primaryModalSelectedMenu: string;
}

const initialState: IModalSlice = {
  showPrimaryModal: false,
  showSecondaryModal: false,
  primaryModalContentOf: '',
  secondaryModalContentOf: '',
  primaryModalSelectedMenu: ''
};

const ModalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    updatePrimaryModalVisibility: (state, { payload }: PayloadAction<boolean>) => {
      state.showPrimaryModal = payload;
    },
    updateSecondaryModalVisibility: (state, { payload }: PayloadAction<boolean>) => {
      state.showSecondaryModal = payload;
    },
    setPrimaryModalContentOf: (state, { payload }: PayloadAction<string>) => {
      state.primaryModalContentOf = payload;
    },
    setSecondaryModalContentOf: (state, { payload }: PayloadAction<string>) => {
      state.secondaryModalContentOf = payload;
    },
    setPrimaryModalSelectedMenu: (state, { payload }: PayloadAction<string>) => {
      state.primaryModalSelectedMenu = payload;
    }
  }
});

export const {
  updatePrimaryModalVisibility,
  updateSecondaryModalVisibility,
  setPrimaryModalContentOf,
  setSecondaryModalContentOf,
  setPrimaryModalSelectedMenu
} = ModalSlice.actions;

export default ModalSlice.reducer;
